var $ = require('jquery');

var self = {};

self.initialise = function($optionHover) {
  $('.pop-up').hide();
  $('.option-container').hover(
    function() {
      //on hover add class active
      $(this).addClass('active');
      $(this)
        .children('.option-box')
        .animate({ opacity: 0 });
      $(this)
        .children('.pop-up')
        .stop()
        .slideDown('fast');
      //$(".pop-up").stop().slideDown("fast");
    },
    function() {
      //off hover remove class
      $(this).removeClass('active');
      $(this)
        .children('.option-box')
        .animate({ opacity: 1 });
      $(this)
        .children('.pop-up')
        .stop()
        .slideUp('fast');
    }
  );
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/optionsHover.js